export default __webpack_public_path__ + "1eb8cf8.png";